import { $ } from "@/plug/Axios";

export default {
  /**
   * 电视播报
   */
  tvPage_broadcastInfo: {
    /*
     * 播报信息
     */
    get: (p, c) => $.get("/api/bms/page/tvPage/broadcastInfo", p, c)
  },
  tvPage_getCatch: {
    /*
     * 取缓存信息
     * key key (string query required)
     */
    get: (p, c) => $.get("/api/bms/page/tvPage/getCatch", p, c)
  }
};
